/* Last-used workspace id, for default redirects ("/" → /w/<id>). localStorage
 * can throw (private mode, disabled storage) — degrade to no memory.
 *
 * The key is shared with the sibling Harness Optimizer app (OPSS-379) — both
 * apps live on one origin (hopt at /harness), and hopt uses it to deep-link back
 * into the workspace the user last had open here. The old per-app key is read
 * as a fallback so existing browsers keep their memory; the next visit that
 * resolves a workspace writes the shared key. */

const KEY = "ai21.workspaceId";
const LEGACY_KEY = "igw.workspaceId";

export function readStoredWorkspaceId(): string | undefined {
  try {
    return (
      window.localStorage.getItem(KEY) ??
      window.localStorage.getItem(LEGACY_KEY) ??
      undefined
    );
  } catch {
    return undefined;
  }
}

export function storeWorkspaceId(id: string): void {
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    // Best effort only.
  }
}

export function clearStoredWorkspaceId(): void {
  try {
    window.localStorage.removeItem(KEY);
    window.localStorage.removeItem(LEGACY_KEY);
  } catch {
    // Best effort only.
  }
}
